// primary synthetic population to use
export const SYN_DATASET_US = 'sp2026q1_us';
export const SYN_DATASET_CA = 'sp2023q3_ca';

export const isCurrentSynthDataset = (countryCode, dataset) => {
  const currentDataset = countryCode === 'ca' ? SYN_DATASET_CA : SYN_DATASET_US;
  return dataset === currentDataset;
};

// Population data
const US_POPULATION = {
  sp2022q2_us: 327056000,
  sp2023q3_us: 259962244,
  sp2026q1_us: 264935333,
};

const CA_POPULATION = {
  sp2023q1_ca: 31204623,
  sp2023q3_ca: 32433918,
  sp2026q1_ca: 33597827,
};

export const TOTAL_POPULATION = {
  us: {
    ...US_POPULATION,
    default: US_POPULATION[SYN_DATASET_US],
  },
  ca: {
    ...CA_POPULATION,
    default: CA_POPULATION[SYN_DATASET_CA],
  },
  undefined: 0,
};

//
